/**
 * Custom Javascript  Code for PROfertil theme Modals and Callouts.
 *
 * @author Eberhard Lauth
 *
 */

( function ( $ ) {

    $(document).ready(function() {
        
        /*Contact Modal*/
        /*$('.contact a').click(function(e) {
            $('#contact-callout').foundation('toggle');
            e.preventDefault(); //prevent scroll to top
            return false;
        });*/
        
        /* Open modal once, then set cookie*/
        if (Cookies.get('help_modal_shown') == null) {
            Cookies.set('help_modal_shown', 'yes', {
                expires: 1,
                path: '/'
            });
            setTimeout(function (event) {
                $('#contact-callout').foundation('toggle');
            }, 18000);
        }
        
        /*Medical Disclaimer Modal*/
        var url = null;
        $('.disclaimer a').click(function(e) {
            url = ($(this).attr('href'));
            e.preventDefault();
            $('#medical-disclaimer').foundation('open');
            $('a.direction-url').attr('href',url);
        });
        
        /*Apotheken Modal*/
        $('.apotheke a').click(function(e) {
            $('#apotheken-modal').foundation('open');
        });
        $('a.apotheke-alt').click(function(e) {
            $('#apotheken-modal-alt').foundation('open');
        });
        
        /*Forward Modal*/
        var destination = null;
        var count = null;
        $('.forward a').click(function (e) {
            destination = ($(this).attr('href'));
            e.preventDefault();
            var count = 5;
            $('p.countdown').html(count);
            $('#forward-message').foundation('open');
            var countdown = setInterval(function () {
                $('p.countdown').html(count);
                if (count == 0) {
                    clearInterval(countdown);
                    window.open(destination, '_self');

                }
                count--;
            }, 1000);
        });
        
    });

} )( jQuery );